// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Scroll from "react-scroll";
import Actions from "../../actions/Creators";
import I18n from "../../i18n/I18n";
import Helper from "../../helper/Helper";
import Dropdown from "../../components/common/filterDropdown/Dropdown";
import {
    Layout,
    Loader,
    Button,
    Icon,
    ToggleButton,
    EmptyResults,
    SearchString,
    Pagination
} from "../../components/common/";
import { Stocks } from "../../components/inventory/index";
import styles from "./Inventory.scss";

type State = {
    inventoryType: Number,
    limits: Number
};

class Inventory extends Component<void, State> {
    state = {
        limits: 40,
        inventoryType: 1,
        selectedWh: 1,
        page: 1,
        location: "all",
        search: "",
        key: "qty_total",
        dir: "desc"
    };

    componentDidMount = () => {
        this.getInventoryStock(this.state.inventoryType);
        this.getWareHouses();
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (
            this.state.inventoryType !== prevState.inventoryType ||
            this.state.change
        ) {
            this.getInventoryStock(this.state.inventoryType);
            Scroll.animateScroll.scrollToTop({ delay: 0 });
        }
    };

    componentWillReceiveProps = nextProps => {
        if (
            this.props.match !== nextProps.match ||
            this.props.seller !== nextProps.seller
        ) {
            this.getWareHouses();
            // this.getInventoryStock(this.state.inventoryType);
        }
    };

    getInventoryStock = () => {
        const {
            inventoryType,
            limits,
            page,
            search,
            selectedWh,
            key,
            dir,
            isExport
        } = this.state;
        let type = "";
        switch (inventoryType) {
            case 1:
                type = "summary";
                break;

            case 2:
                type = "rejected";
                break;
            case 4:
                type = "unidentified";
                break;
            case 3:
                type = "damaged";
                break;

            default:
        }
        let query = `?limits=${isExport ? 7000 : limits}&page=${
            isExport ? 1 : page
        }`;
        query = inventoryType ? `${query}&type=${type}` : "";
        query = search ? `${query}&search=${search}` : query;
        query = isExport ? `${query}&is_export=1` : query;
        query =
            selectedWh !== 1 ? `${query}&warehouse_code=${selectedWh}` : query;
        query = key && dir ? `${query}&dir=${dir}&sort=${key}` : query;
        this.props.dispatch(Actions.getInventoryStock(query));
        this.setState({
            change: false,
            isExport: false
        });
    };

    toggleType = type => {
        const newState = {};
        if (this.state.inventoryType !== type) newState.page = 1;
        newState.inventoryType = type;
        newState.key = type === 1 ? "qty_total" : "qty";
        newState.dir = "desc";
        this.setState(newState);
    };

    onSearch = search => {
        const newState = {};
        newState.page = 1;
        newState.search = search;
        newState.key = "";
        newState.dir = "";
        newState.change = true;
        this.setState(newState);
    };

    onPageChange = page => {
        const newState = {};
        newState.page = page.selected + 1;
        newState.change = true;
        this.setState(newState);
    };

    clearSearch = () => {
        const newState = {};
        newState.search = "";
        newState.key = "";
        newState.dir = "";
        newState.change = true;
        this.setState(newState);
    };

    perPage = e => {
        const newState = {};
        newState.limits = e;
        newState.page = 1;
        newState.change = true;
        this.setState(newState);
    };
    chooseWh = e => {
        const newState = {};
        newState.selectedWh = e;
        newState.page = 1;
        newState.key = "";
        newState.dir = "";
        newState.change = true;
        this.setState(newState);
    };

    sortColumn = (key, dir) => {
        const newState = {};
        newState.key = key;
        newState.dir = dir;
        newState.page = 1;
        newState.change = true;
        this.setState(newState);
    };

    getWareHouses = () => {
        this.props.dispatch(Actions.getInventoryWarehouse());
    };

    exportInventory = () => {
        const newState = {};
        newState.isExport = true;
        newState.change = true;
        this.setState(newState);
    };

    render() {
        const {
            browser,
            isSessionLoading,
            isLoading,
            inventory,
            seller,
            warehouses
        } = this.props;

        const linkEn =
            "https://help.noon.partners/hc/en-us/articles/360007634913?utm_source=seller_lab&utm_medium=inventory&utm_campaign=more_info";
        const linkAr =
            "https://help.noon.partners/hc/ar/articles/360007634913?utm_source=seller_lab&utm_medium=inventory&utm_campaign=more_info";
        const localeLink = Helper.getLang() === "en" ? linkEn : linkAr;

        const text = (
            <div>
                {I18n.getText("inventory.help-tooltip")}{" "}
                <a
                    className={styles.helpLink}
                    href={localeLink}
                    target="_blank"
                >
                    {I18n.getText("inventory.help-tooltip-link")}
                </a>
            </div>
        );

        const { selectedWh, dir, key } = this.state;

        const toggleItems = [
            I18n.getText("inventory.summary"),
            I18n.getText("inventory.quality-rejections"),
            I18n.getText("inventory.damage"),
            I18n.getText("inventory.unidentified")
        ];

        let sorted =
            inventory.inventoryStock && inventory.inventoryStock.stocks;

        // if (
        //   inventory.inventoryStock &&
        //   inventory.inventoryStock.stocks &&
        //   !_.isEmpty(inventory.inventoryStock.stocks) &&
        //   (this.state.inventoryType === 2 || this.state.inventoryType === 3)
        // ) {
        //   sorted = _.orderBy(
        //     inventory.inventoryStock.stocks,
        //     ["barcode_box", "reason_code"],
        //     ["asc"]
        //   );
        // }

        // const result = _.chain(sorted)
        //   .groupBy("barcode_box", "reason_code", "warehouse_code", "area_code")
        //   // .toPairs()
        //   .map(function(currentItem) {
        //     const retObj = {};
        //     retObj["barcode_box"] = currentItem[0].barcode_box;
        //     retObj["reason_code"] = currentItem[0].reason_code;
        //     retObj["warehouse_code"] = currentItem[0].warehouse_code;
        //     retObj["area_code"] = currentItem[0].area_code;
        //     retObj["items"] = _.map(currentItem, function(o) {
        //       return _.omit(o, [
        //         "barcode_box",
        //         "reason_code",
        //         "warehouse_code",
        //         "area_code"
        //       ]);
        //     });
        //     return retObj;
        //     // return _.zip(["barcode_box", "items"], currentItem);
        //   })
        //   .value();

        // if (this.state.inventoryType === 2 || this.state.inventoryType === 3) {
        //     sorted = result;
        // }

        const pageOptions = [
            {
                value: 40,
                key: 40,
                label: I18n.getText("stock-requests.per-page", { count: 40 })
            },
            {
                value: 80,
                key: 80,
                label: I18n.getText("stock-requests.per-page", { count: 80 })
            },
            {
                value: 120,
                key: 120,
                label: I18n.getText("stock-requests.per-page", { count: 120 })
            }
        ];

        const wareHousesOptions = [
            { value: 1, key: 1, label: I18n.getText("orders.All") }
        ];
        if (warehouses && warehouses.warehouses) {
            for (let i = 0; i < warehouses.warehouses.length; i++) {
                wareHousesOptions.push({
                    value: warehouses.warehouses[i].partner_code,
                    key: warehouses.warehouses[i].partner_code,
                    label: `${warehouses.warehouses[i].display_name} - ${
                        warehouses.warehouses[i].city
                    }`
                });
            }
        }

        return (
            <Layout
                currentIndex={9}
                title={"menu.inventory"}
                search={this.state.search}
                searchLabel={"orders.new-search-placeholder"}
                onSearch={this.onSearch}
                text={text}
            >
                {!isSessionLoading && seller ? (
                    <div>
                        {seller.is_allow_fbn_asn ||
                        seller.force_is_fbn_eligible ? (
                            <div className={styles.inventoryCtr}>
                                {/* TABS AND FILTER START */}
                                <div className={styles.topWrapper}>
                                    {/* TOGGLE TABS STARTS */}
                                    <ToggleButton
                                        toggleBtn={this.toggleType}
                                        toggleItems={toggleItems}
                                        selected={this.state.inventoryType}
                                    />
                                    {/* TOGGLE TABS ENDS */}

                                    <div className={styles.filterCtr}>
                                        {inventory &&
                                            inventory.inventoryStock &&
                                            inventory.inventoryStock.stocks &&
                                            !_.isEmpty(
                                                inventory.inventoryStock.stocks
                                            ) && (
                                                <div
                                                    className={
                                                        styles.eachFilter
                                                    }
                                                >
                                                    <Button
                                                        className={
                                                            styles.flexer
                                                        }
                                                        variant="transparent"
                                                        onClick={() =>
                                                            this.exportInventory()
                                                        }
                                                    >
                                                        <Icon
                                                            name="download"
                                                            className={
                                                                styles.icon
                                                            }
                                                        />
                                                        {I18n.getText(
                                                            "products.export-all"
                                                        )}
                                                    </Button>
                                                </div>
                                            )}
                                        <div className={styles.eachFilter}>
                                            <Dropdown
                                                onChange={this.chooseWh}
                                                selected={selectedWh}
                                                options={wareHousesOptions}
                                                label={I18n.getText(
                                                    "offer.warehouse-code"
                                                )}
                                            />
                                        </div>
                                        <div className={styles.eachFilter}>
                                            <Dropdown
                                                onChange={this.perPage}
                                                selected={this.state.limits}
                                                options={pageOptions}
                                                label={I18n.getText(
                                                    "orders.display",
                                                    {},
                                                    "Display"
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* TAB AND FILTER ENDS */}

                                <div>
                                    {this.state.search ? (
                                        <SearchString
                                            search={this.state.search}
                                            clearSearch={this.clearSearch}
                                        />
                                    ) : (
                                        ""
                                    )}
                                </div>

                                {!isLoading ? (
                                    <div>
                                        {inventory &&
                                        inventory.inventoryStock &&
                                        inventory.inventoryStock.stocks &&
                                        !_.isEmpty(
                                            inventory.inventoryStock.stocks
                                        ) ? (
                                            <div className={styles.tableWraper}>
                                                <Stocks
                                                    browser={browser}
                                                    data={sorted}
                                                    inventoryType={
                                                        this.state.inventoryType
                                                    }
                                                    searchString={
                                                        this.state.search
                                                    }
                                                    sortColumn={this.sortColumn}
                                                    keyVal={key}
                                                    dir={dir}
                                                />
                                            </div>
                                        ) : (
                                            <EmptyResults
                                                heading={I18n.getText(
                                                    "inventory.no-inventory",
                                                    {
                                                        type:
                                                            toggleItems[
                                                                this.state
                                                                    .inventoryType -
                                                                    1
                                                            ]
                                                    }
                                                )}
                                            />
                                        )}
                                        {inventory &&
                                        inventory.inventoryStock &&
                                        inventory.inventoryStock.no_of_pages &&
                                        inventory.inventoryStock.no_of_pages >
                                            1 ? (
                                            <div
                                                className={
                                                    styles.paginationWrapper
                                                }
                                            >
                                                <Pagination
                                                    pageCount={Number(
                                                        inventory.inventoryStock
                                                            .no_of_pages
                                                    )}
                                                    currentPage={
                                                        this.state.page
                                                    }
                                                    onPageChange={
                                                        this.onPageChange
                                                    }
                                                />
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                ) : (
                                    <Loader />
                                )}
                            </div>
                        ) : (
                            <EmptyResults
                                heading={I18n.getText(
                                    "inventory.no-inventory",
                                    { type: "" }
                                )}
                            />
                        )}
                    </div>
                ) : (
                    <Loader />
                )}
            </Layout>
        );
    }
}
const mapStateToProps = state => {
    return {
        lang: state.locale.lang,
        user: state.session.user,
        seller: state.session.seller,
        session: state.session,
        isSessionLoading: state.session.isSessionLoading,
        isLoading: state.inventory.isLoading,
        browser: state.browser,
        inventory: state.inventory,
        warehouses: state.inventory.warehouses
    };
};

export default connect(mapStateToProps)(Inventory);



// WEBPACK FOOTER //
// ./src/containers/inventory/Inventory.js